import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { User } from '../../../_models/user';
import { AuthService } from '../../../_services/auth.service';
import { NavbarServiceService } from '../navbar-service.service';

declare const $: any;


export interface RouteTitle {
    title: string;
    routeInfos: RouteInfo[];
}

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    iconName?: string;
    ab?: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteTitle[] = [
    {
        title: 'FINANSIJE',
        routeInfos: [
            {
                path: '/finance',
                title: 'Finansije',
                type: 'link',
                icontype:  '/assets/img/sidebar-icons/finance-icon.svg'
            },
            {
                path: '',
                title: 'Nov',
                type: 'dropdown',
                icontype:  '/assets/img/sidebar-icons/finance-icon.svg',
                children: [
                    {
                        path: '/finance/client',
                        title: 'Stranka',
                        iconName: '/assets/img/finance-icons/client-icon.svg'
                    },
                    {
                        path: '/finance/item',
                        title: 'Artikal',
                        iconName: '/assets/img/finance-icons/product-service-icon.svg'
                    },
                    {
                        path: '/finance/document',
                        title: 'Numeracija dokumenta',
                        iconName: '/assets/img/finance-icons/numbering-document-icon.svg'
                    },
                    {
                        path: '/finance/account',
                        title: 'Izdat racun',
                        iconName: '/assets/img/finance-icons/invoice-issued-icon.svg'
                    },
                    {
                        path: '/izrada',
                        title: 'Primljen racun',
                        iconName: '/assets/img/finance-icons/invoice-received-icon.svg'
                    },
                    {
                        path: '/finance/addExchangeRate',
                        title: 'Kursna lista',
                        iconName: '/assets/img/finance-icons/numbering-document-icon.svg'
                    }

                ]

            },
            {
                path: '',
                title: 'Poslovanje',
                type: 'dropdown',
                icontype:  '/assets/img/finance-icons/finance-icon.svg',
                children: [
                    {
                        path: '/finance/business/client',
                        title: 'Stranka',
                        iconName: '/assets/img/finance-icons/client-icon.svg'
                    },
                    {
                        path: '/finance/business/item',
                        title: 'Artikal',
                        iconName: '/assets/img/finance-icons/product-service-icon.svg'
                    },
                    {
                        path: '/finance/documentShow',
                        title: 'Numeracija dokumenta',
                        iconName: '/assets/img/finance-icons/numbering-document-icon.svg'
                    },
                    {
                        path: '/finance/invoicesAccount',
                        title: 'Primljeni račun',
                        iconName:  '/assets/img/finance-icons/invoice-received-icon.svg'
                    },
                    {
                        path: '/finance/ExchangerateShow',
                        title: 'Kursna lista',
                        iconName: '/assets/img/finance-icons/exchange-icon.svg'
                    },
                    {
                        path: '/finance/displayAllAccount',
                        title: 'Spisak faktura',
                        iconName: '/assets/img/finance-icons/numbering-document-icon.svg'
                    },
                    {
                        path: '/finance/invoiceGroups',
                        title: 'Grupe faktura',
                        iconName: '/assets/img/finance-icons/numbering-document-icon.svg'
                    }
                ]
            },
            {
                path: '',
                title: 'Knjigovodstvo',
                type: 'dropdown',
                icontype:  '/assets/img/sidebar-icons/finance-icon.svg',
                children: [
                    {
                        path: '/finance/openItem',
                        // path: '/izrada',
                        title: 'Otvorene stavke',
                        iconName: '/assets/img/finance-icons/open-item-icon.svg'
                    },
                    {
                        path: '/finance/bookkeeping-clients',
                        title: 'Kartice stranke',
                        iconName: '/assets/img/finance-icons/client-card-icon.svg'
                    },
                    {
                        path: '/izrada',
                        title: 'IOS',
                        iconName: '/assets/img/finance-icons/invoice-received-icon.svg'
                    },
                    {
                        path: '/izrada',
                        // path: '/finance/bookkeeping-incoming-invoices',
                        title: 'Ulazne fakture',
                        iconName: '/assets/img/finance-icons/invoice-received-icon.svg'
                    },
                ]
            },
            {
                path: '',
                title: 'Banke',
                type: 'dropdown',
                icontype:  '/assets/img/sidebar-icons/finance-icon.svg',
                children: [
                    {
                        path: '/finance/business/accountStatement',
                        title: 'Izvodi banaka',
                        iconName: '/assets/img/finance-icons/account-state-icon.svg'
                    },
                    {
                        path: '/finance/bankBalance',             
                        title: 'Stanje banaka',
                        iconName: '/assets/img/finance-icons/bank-icon.svg'
                    }

                ]
            },
            {
                path: '',
                title: 'podešavanja',
                type: 'dropdown',
                icontype:  '/assets/img/sidebar-icons/settings-icon.svg',
                children: [
                    {
                        path: '/finance/accountSettings',
                        title: 'Podešavanje računa',
                        iconName: '/assets/img/finance-icons/settings-icon.svg'
                    },
                    {
                        path: '/finance/financial-accounts',
                        title: 'Tekući računi',
                        iconName: '/assets/img/finance-icons/settings-icon.svg'
                    },
                    {
                        
                        path: '/finance/emailSettings',
                        title: 'Opomene',
                        iconName: '/assets/img/finance-icons/settings-icon.svg'
                    }
                ]
            }
        ]
    },
    {
        title: 'GPS',
        routeInfos: [
            {
                path: '/dashboard',
                title: 'Panel',
                type: 'link',
                icontype: '/assets/img/sidebar-icons/dashboard-icon.svg'
            },
            {
                path: '/companies',
                title: 'Kompanije',
                type: 'link',
                icontype: 'emoji_transportation'
            },
            {
                path: '/users',
                title: 'Korisnici',
                type: 'link',
                icontype: 'group'
            },
            {
                path: '/modems',
                title: 'Modemi',
                type: 'link',
                icontype: 'dns'
            },
            {
                path: '/adminVehicles',
                title: 'Vozila',
                type: 'link',
                icontype: 'directions_car'
            },
            {
                path: '/logisticagents',
                title: 'Logistički agenti',
                type: 'link',
                icontype: 'local_shipping'
            }
        ]
    },
    {
        title: `SRB`,
        routeInfos: [
            {
                path: `/srbToll/clients`,
                title: `Klijenti`,
                type: `link`,
                icontype: '/assets/img/sidebar-icons/highway-icon.svg'
            },
            {
                path: ``,
                title: `Tagovi`,
                type: `dropdown`,
                icontype: `toll`,
                children: [
                    {
                        path: `/srbToll/tags`,
                        title: `Tagovi`,
                        iconName: '/assets/img/sidebar-icons/enpay-icon.svg'
                    },
                    {
                        path: '/srbToll/tagGroups',
                        title: 'Grupisani tagovi',
                        iconName: '/assets/img/sidebar-icons/enpay-icon.svg'
                    }
                ]
            },
            {
                path: ``,
                title: `Specifikacije`,
                type: `dropdown`,
                icontype: `toll`,
                children: [
                    {
                        path: '/srbToll/specifications',
                        title: 'Specifikacije',
                        iconName: '/assets/img/sidebar-icons/open-item-icon.svg'
                    },
                    {
                        path: '/srbToll/specificationReports',
                        title: 'Izveštaji',
                        iconName: '/assets/img/sidebar-icons/open-item-icon.svg'
                    },
                    {
                        path: '/srbToll/specificationZipFiles',
                        title: 'Zip fajlovi',
                        iconName: '/assets/img/sidebar-icons/zip-icon.svg',
                    },
                    {
                        path: '/srbToll/specificationGroups',
                        title: 'Grupe fajlova',
                        iconName: '/assets/img/sidebar-icons/numbering-document-icon.svg',
                    }

                ]
            },
            {
                path: 'srbToll/statistics',
                title: 'Statistika',
                type: 'link',
                icontype: 'toll'
            },
            {
                path: 'srbToll/dataWarehouseHistory',
                title: 'Istorija',
                type: 'link',
                icontype: 'toll'
            }
        ]
    },

    {
        title: `MSTS`,
        routeInfos: [
            {
                path: `/msts/clients`,
                title: `Klijenti`,
                type: `link`,
                icontype: '/assets/img/sidebar-icons/msts-icon.svg'
            },
            {
                path: '',
                title: 'Fajlovi',
                type: 'dropdown',
                icontype: '/assets/img/sidebar-icons/settings-icon.svg',
                children: [
                    {
                        path: 'msts/specificationGroups',
                        title: 'Grupe fajlova',
                        type: 'link',
                        iconName: '/assets/img/sidebar-icons/numbering-document-icon.svg'
                    },
                    {
                        path: 'msts/specificationImportedFiles',
                        title: 'Importovani fajlovi',
                        type: 'link',
                        iconName: '/assets/img/sidebar-icons/numbering-document-icon.svg'
                    },
                ]
            },
            {
                path: '',
                title: 'specifikacije',
                type: 'dropdown',
                icontype:  '/assets/img/sidebar-icons/settings-icon.svg',
                children: [
                    {
                        path: `/msts/specifications`,
                        title: `Specifikacije`,
                        type: `link`,
                        iconName: '/assets/img/sidebar-icons/open-item-icon.svg'
                    },
                    {
                        path: `/msts/specificationReports`,
                        title: `Izveštaji specifikacija`,
                        type: `link`,
                        iconName: '/assets/img/sidebar-icons/open-item-icon.svg'
                    },
                    {
                        path: '/msts/specificationZipFiles',
                        title: 'Zip izvestaji',
                        type: 'link',
                        iconName: '/assets/img/sidebar-icons/zip-icon.svg'
                    }]
            },
            {
                path: 'msts/statistics',
                title: 'Statistika',
                type: 'link',
                icontype: 'toll'
            },
            // {
            //     path: `/msts/transactionGroups`,
            //     title: `Grupe transakcija`,
            //     type: `link`,
            //     icontype: `toll`
            // },
            // {
            //     path: `/msts/transactions`,
            //     title: `Http Transakcije`,
            //     type: `icon`,
            //     icontype: `toll`
            // }
        ]
    },

    {
        title: 'Putarine u Grčkoj',
        routeInfos: [
            {
                path: '/grkToll/clients',
                title: 'Klijenti',
                type: 'link',
                icontype: '/assets/img/sidebar-icons/highway-icon.svg'
            },
            {
                path: '',
                title: 'Tagovi',
                type: 'dropdown',
                icontype: 'toll',
                children: [
                    {
                        path: `/grkToll/tags`,
                        title: `Tagovi`,
                        iconName: '/assets/img/sidebar-icons/enpay-icon.svg'
                    },
                    {
                        path: '/grkToll/specificationTags',
                        title: 'Grupisani tagovi',
                        iconName: '/assets/img/sidebar-icons/enpay-icon.svg'
                    }
                ]
            },
            {
                path: ``,
                title: `Specifikacije`,
                type: `dropdown`,
                icontype: `toll`,
                children: [
                    {
                        path: '/grkToll/specifications',
                        title: 'Specifikacije',
                        iconName: '/assets/img/sidebar-icons/open-item-icon.svg'
                    },
                    {
                        path: '/grkToll/specificationReports',
                        title: 'Lista izveštaja',
                        iconName: '/assets/img/sidebar-icons/open-item-icon.svg'
                    },
                    {
                        path: '/grkToll/specificationReportZipFiles',
                        title: 'Zip izveštaji',
                        iconName: '/assets/img/sidebar-icons/zip-icon.svg',
                    },
                    {
                        path: '/grkToll/specificationFileGroups',
                        title: 'Grupe fajlova',
                        iconName: '/assets/img/sidebar-icons/numbering-document-icon.svg',
                    }
                ]
            },
            {
                path: '/grkToll/statistics',
                title: 'Statistika',
                type: 'link',
                icontype: 'toll'
            }
        ]
    },
    {
        title: `Automatcki izvestaji`,
        routeInfos: [
            {
                path: `/automaticReportsTesting`,
                title: `Testiranje`,
                type: `link`,
                icontype: ''
            },
            
        ]
    }, 
    {
   
        title: 'Testiranje',
        routeInfos: [
            {
                path: '/admin/vehicleMovements',
                title: 'Kretanje vozila',
                type: 'link',
                icontype: 'toll'
            },
            {
                path: '/admin/vehicleMovements_v1',
                title: 'Kretanje vozila (v1)',
                type: 'link',
                icontype: 'toll'
            },
            {
                path: '/admin/vehiclePositionsTest',
                title: 'Poslednje pozicije (performans)',
                type: 'link',
                icontype: 'toll'
            },
            {
                path: '/admin/test/realTimeDashboard',
                title: 'Realno Vremenski Dashboard',
                type: 'link',
                icontype: 'toll'
            }
            
            // {
            //     path: '/admin/lastPositionsTest',
            //     title: 'Poslednje pozicije vozila (Početna)',
            //     type: 'link',
            //     icontype: 'toll'
            // }
        ]
    },
    {
        title: 'Goriva',
        routeInfos: [
            {
                path: '/fuelCompanies',
                title: 'Klijenti',
                type: 'link',
                icontype: '/assets/img/sidebar-icons/fuel-icon.svg'
              },
              {
                path: '/fuelCards',
                title: 'Kartice',
                type: 'link',
                icontype: 'toll'
              },
              {
                  path: '/fuelConsumptions',
                  title: 'Potrošnja',
                  type: 'link',
                  icontype: 'toll'
              },
              {
                  path: '/fuelStatistics',
                  title: 'Statistika',
                  type: 'link',
                  icontype: 'toll'
              }
        ]
    },
    {
        title: `Pumpe`,
        routeInfos: [
            {
                path: `/unauthorized/gasStationPositions`,
                title: `Primer (radi testiranja)`,
                type: `link`,
                icontype: '/assets/img/sidebar-icons/gasstation-icon.svg'
            }
        ]
    },


];

// OBSOLETE
export const ROUTES1: RouteInfo[] = [
    {
        path: '/dashboard',
        title: 'Panel',
        type: 'link',
        icontype: 'dashboard'
    },
    // {
    //     path: '/vehicles',
    //     title: 'Vozila',
    //     type: 'link',
    //     icontype: 'directions_car'
    // },
    // {
    //     path: '/routes',
    //     title: 'Rute',
    //     type: 'link',
    //     icontype: 'map'
    // },
    {
        path: '/companies',
        title: 'Kompanije',
        type: 'link',
        icontype: 'emoji_transportation'
    },
    {
        path: '/clientUsers',
        title: 'Korisnici',
        type: 'link',
        icontype: 'group'
    },
    {
        path: '/modems',
        title: 'Modemi',
        type: 'link',
        icontype: 'dns'
    },
    {
        path: '/allvehicles',
        title: 'Vozila',
        type: 'link',
        icontype: 'directions_car'
    },
    {
        path: '/logisticagents',
        title: 'Logistički agenti',
        type: 'link',
        icontype: 'local_shipping'
    },
    // {
    //     path: '/lockers',
    //     title: 'Ormani',
    //     type: 'sub',
    //     icontype: 'view_module',
    //     collapse: 'lockers',
    //     children: [
    //         {path: '', title: 'Lista ormana', ab: 'LO'},
    //         {path: 'new', title: 'Kreiraj orman', ab: 'KO'}
    //     ]
    // }
];
@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems = ROUTES;
    user: User;

    constructor(private authService: AuthService,
                private navbarService: NavbarServiceService) { }

    sendDataToService() {
        this.navbarService.setNavbarData(this.menuItems);
   }

   sendLinkInfo(linkInfo) {
    this.navbarService.setNavbarData(linkInfo);
   }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }

    ngOnInit() {
        this.user = this.authService.getAdminUser();
        this.sendDataToService();
    }

    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            let ps = new PerfectScrollbar(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('admin-token');
        localStorage.removeItem('client-token');
        localStorage.removeItem('serviceMan-token');
    }
}
